import Container from "../../../../components/container";
import { Allergy, AllergyCategory } from "../../../../models";
import { AllergyCategoryViewModel } from "../../../../viewModels";
import AllergyCreateForm from "./allergy-create-form";
import { DeleteAllergyButton } from "./buttons";

export default function AllergiesTable({category}:{category:AllergyCategoryViewModel}){
     return (
           <Container className="max-w-xl  text-left">
             <table className="min-w-full text-gray-900 text-left ">
               <thead className="rounded-lg text-left text-sm font-normal">
                 <tr>
                   <th scope="col" className="px-6 py-3">
                     Allergy
                   </th>
       
                   <th scope="col" className="px-6 py-3">
                     <span className="sr-only">Edit</span>
                   </th>
                 </tr>
               </thead>
               <tbody className="bg-white">
                 {category.allergies.map((item) => (
                   <tr key={item.id}                   className="w-full text-left border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg"
>
                     <td className="whitespace-nowrap px-6 py-3">{item.name}</td>
       
                     <td className="px-6 py-4">
                        {item.id ? (
                         <div className="flex flex-1 items-center justify-end gap-2">
                           {/* <UpdateButton id={category.id} /> */}
                           <DeleteAllergyButton allergy={item} />
                         </div>
                       ) : null} 
                     </td>
                   </tr>
                 ))}
               </tbody>
               <tfoot>
                <tr>
                  <td colSpan={2}  className="px-6 py-4">
                    <AllergyCreateForm category={category}></AllergyCreateForm>
                  </td>
                </tr>
               </tfoot>
             </table>
           </Container>
         );
       }
        
